import React from "react";
import { Grid } from "@mui/material";
import { ProcessorQCTable } from "./ProcessorQCTable";
import { PreProcessorQCTable } from "./PreProcessorQCTable";
import { ValidatorQCTable } from "./ValidatorQCTable";

const QCTable = React.forwardRef(
  (
    {
      role,
      selectedFile,
      qcTemplateData,
      showParameterTable,
      assignToValidator,
    },
    ref
  ) => {
    return (
      <Grid container>
        {role === "preProcessor" ? (
          <Grid item xs={12}>
            <PreProcessorQCTable
              // qcTemplateData={qcTemplateData}
              role={role}
              selectedFile={selectedFile}
              ref={ref} // forward the ref properly here
              showParameterTable={showParameterTable}
            />
          </Grid>
        ) : role === "processor" ? (
          <Grid item xs={12}>
            <ProcessorQCTable
              // qcTemplateData={qcTemplateData}
              role={role}
              selectedFile={selectedFile}
              ref={ref} // forward the ref properly here
              showParameterTable={showParameterTable}
              assignToValidator={assignToValidator}
            />
          </Grid>
        ) : (
          role === "validator" && (
            <Grid item xs={12}>
              <ValidatorQCTable
                // qcTemplateData={qcTemplateData}
                role={role}
                selectedFile={selectedFile}
                ref={ref} // forward the ref properly here
                showParameterTable={showParameterTable}
                // assignToValidator={assignToValidator}
              />
            </Grid>
          )
        )}
      </Grid>
    );
  }
);

export default QCTable;
